export function getInspectionAccessUrl(token) {
  const url = new URL(process.env.REACT_APP_INSPECTION_URL);
  if (!['http:', 'https:'].includes(url.protocol)) throw new Error('Invalid inspection application URL.');
  url.searchParams.set('token', token);
  return url.href;
}

export function redirectToInspection(url) {
  window.location.replace(url);
}
